import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import type {
	ContentHeaderPresenceContentSettingsQuery$data,
	ContentHeaderPresenceContentSettingsQuery$variables,
} from './presence/__generated__/ContentHeaderPresenceContentSettingsQuery.graphql.ts';
import ContentHeaderPresenceContentSettingsQuery from './presence/__generated__/ContentHeaderPresenceContentSettingsQuery.graphql.ts';

export function preloadPresenceSettings({
	cloudId,
	spaceKey,
}: {
	cloudId: string;
	spaceKey: string;
}) {
	return query<
		ContentHeaderPresenceContentSettingsQuery$data,
		ContentHeaderPresenceContentSettingsQuery$variables
	>({
		query: ContentHeaderPresenceContentSettingsQuery,
		variables: {
			cloudId,
			spaceKey,
		},
	});
}
